import { render, staticRenderFns } from "./JgShareConfig.vue?vue&type=template&id=27fd2627&scoped=true"
import script from "./JgShareConfig.vue?vue&type=script&lang=js"
export * from "./JgShareConfig.vue?vue&type=script&lang=js"
import style0 from "./JgShareConfig.vue?vue&type=style&index=0&id=27fd2627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd2627",
  null
  
)

export default component.exports